import { SettingsActions, SettingsActionTypes } from '@dwo/actions';
import { FeatureSettingsDto, WebSocketSettingsDto } from '@app/generated/model';

export const initialState: SettingsState = {
  features: null,
  token: null,
  webSocket: null,
};

export interface SettingsState {
  features?: FeatureSettingsDto;
  token?: string;
  webSocket?: WebSocketSettingsDto;
}

export function settingsReducer(state: SettingsState = initialState, action: SettingsActions): SettingsState {
  switch (action.type) {
    case SettingsActionTypes.LoadSettingsSuccess:
      return {
        ...state,
        features: action.settingsDto.features,
        token: action.settingsDto.token,
        webSocket: action.settingsDto.webSocket,
      };
    default:
      return {
        ...state,
      };
  }
}
